export default {
  eventTypeFilters: "Event types"
}